import script from "./ValidatedSchedaPopUp.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidatedSchedaPopUp.vue?vue&type=script&setup=true&lang=js"

import "./ValidatedSchedaPopUp.vue?vue&type=style&index=0&id=2b8a16fa&lang=css"

const __exports__ = script;

export default __exports__